//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Topics from './filters/Topics'
import ContentTypes from './filters/ContentTypes'
import BusinessCategories from './filters/BusinessCategories'
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "AppFiters",
  	props: ['showContentTypesFilter'],
	components: {
		appTopics: Topics,
		appContentTypes: ContentTypes,
		appBusinessCategories: BusinessCategories
	},
	data(){
		return{
			isLeft:false
		}
	},
	computed: {
		...mapGetters(["contentTypes", "topics", "businessCategories"]),
	},
	methods: {
		checkAlignment() {
			const filters = this.$el.closest('.filterItems')
			const parent = filters.parentElement
			const siblings = [...parent.querySelectorAll(':scope > *')]
			let isLeft = siblings.some((sibling, i) => {
				if (i >= siblings.indexOf(filters)) return false
				return sibling.classList.contains('headerUtil--left')
			})
			this.isLeft = isLeft
		}
	},
	mounted(){this.checkAlignment()}
};
